import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const PLANK = "#c9a36a";
const PLANK_EDGE = "#a07a44";

function plankUnit(cx: number, cy: number, cz: number, w: number, d: number): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(w, 0.018, d), color: PLANK, position: [cx, cy, cz] },
    { geometry: new THREE.BoxGeometry(w, 0.02, 0.008), color: PLANK_EDGE, position: [cx, cy, cz + d / 2 - 0.004] },
  ];
}

export const plankBundle = defineModel({
  id: "plank-bundle",
  batchId: "characters",
  name: "Plank bundle",
  tags: ["good", "cargo", "wood"],
  fits: ["carry"],
  summary: "A small stack of sawn planks -- a carriable good for an avatar's carry socket.",
  description:
    "Three layered planks at held scale, ported from age-of-mcp's goods (`plank`). " +
    "Mount it in a player's or worker's `carry` socket to show the figure " +
    "hauling planks.",
  author: "age-of-mcp",
  footprint: 0.1,
  parts: (): Part[] => [
    ...plankUnit(0, 0.03, 0.0, 0.16, 0.1),
    ...plankUnit(0, 0.052, 0.0, 0.16, 0.1),
    ...plankUnit(0, 0.074, 0.0, 0.16, 0.1),
  ],
  animations: [],
});
